import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { useBoolean } from '@rothzerg/useboolean'
import { createUseStyles, useTheme } from 'react-jss'

import { getCookie } from '../../../../utils/cookies'
import FormInput from '../../Form/FormInput'

let useStyles = createUseStyles({
  bookingWidgetWrapper: ({ theme }) => ({
    //backgroundColor: bgColor || theme.colors.blue,
    backgroundColor: theme.colors.blue,
    maxHeight: 700,
    margin: '50px 0 0',
    padding: 0,
    '& .picstrip': {
      display: 'block',
    },
    '& .emptyspace': {
      display: 'none',
    },

    '&.is-closed': {
      '& .con , & .con2, & .globalLocationsIntro': {
        display: 'none',
      },
      '& .picstrip': {
        display: 'none',
      },
      '& .emptyspace': {
        display: 'block',
      },
    },
    '& .globalLocationsIntro': {
      ...theme.wrappers.standard,
      padding: '7px 37px 16px',
      fontSize: '15px',
      color: 'white',
      fontFamily: 'TTRounds',
      fontWeight: '700',
    },
    '& .con, & .con2': {
      '@media (max-width: 900px)': {
        maxWidth: 400,
      },
    },
    '& .con': {
      ...theme.wrappers.standard,
      display: 'flex',
      flexWrap: 'nowrap',
      paddingBottom: 0,
      paddingTop: 7,
      width: '100%',
      justifyContent: 'space-between',
      // "@media (max-width: 1200px)": {
      '@media (max-width: 1400px)': {
        flexWrap: 'wrap',
        justifyContent: 'unset',
      },
    },
    '& .con2': {
      ...theme.wrappers.standard,
      display: 'flex',
      flexWrap: 'nowrap',
      width: '100%',
      paddingBottom: 25,
      '@media (max-width: 1400px)': {
        flexWrap: 'wrap',
        justifyContent: 'unset',
      },
    },
    '& .react-datepicker-popper': {
      zIndex: '100 !important',
    },
    '& .select__menu': {
      zIndex: '100 !important',
    },
    '& .btnbs': {
      backgroundColor: theme.colors.orange,
      border: 'none',
      borderRadius: '14px',
      color: '#fff',
      fontFamily: 'TTRounds',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '15px',
      lineHeight: '17px',
      textAlign: 'center',
      padding: '13px 41px',
      '&:hover': {
        backgroundColor: theme.colors.orangeHover,
        cursor: 'pointer',
      },
    },
    '& .campaignlink': {
      display: 'flex',
      alignItems: 'center',
      color: '#333',
      textDecoration: 'none',
      fontWeight: 500,
      padding: '5px',
      borderRadius: '4px',
      '& img': {
        backgroundColor: '#ccc',
        height: '25px',
        width: '40px',
        marginRight: '10px',
      },
      '&:hover': {
        backgroundColor: '#f1f1f1',
      },
    },
  }),
})

export const BookingWidget = ({
  promoCampaign,
  bluechipWrapperRef,
  blueChipMemberDropdown,
  setBlueChipMemberDropdown,
  bluechipnumber,
  setbluechipnumber,
  bluechipname,
  setbluechipname,
  setblueChipMembershipActive,
  bgColor,
  widgetOpen,
  setSearchDiscountcode,
  setVelocityDropdown,
  velocityDropdown,
  velocityWrapperRef,
  setvelocitynumber,
  velocitynumber,
  children,
}) => {
  const theme = useTheme()
  const classes = useStyles({ bgColor, theme })
  const [popup, setPopup] = useBoolean()

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setPopup.false()
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)

  const [blueschipError, setblueschipError] = useState(undefined)
  const [bluechiperror, setbluechiperror] = useBoolean()
  const [bluechipsuccess, setbluechipsuccess] = useBoolean()
  const [blueChipMembershipDisable, setblueChipMembershipDisable] = useBoolean()

  const _checkBlueChip = () => {
    if (bluechipnumber !== '' && bluechipname !== '') {
      const params = new URLSearchParams()
      params.append('bluechipname', bluechipname)
      params.append('memberId', bluechipnumber)
      params.append('membertype', 'BC')
      setblueChipMembershipDisable.true()
      axios
        .post('/api/getmember', params)
        .then(({ data }) => {
          setblueChipMembershipDisable.false()
          setbluechiperror.false()
          setbluechipsuccess.false()

          if (data.status === true) {
            setblueChipMembershipActive.true()
            setbluechipsuccess.true()
            setSearchDiscountcode('2226214')
          } else {
            // setPopup.true()
            setbluechiperror.true()
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  return (
    <div
      id={'formBook'}
      className={`${classes.bookingWidgetWrapper} ${widgetOpen ? '' : 'is-closed'}`}
    >
      {popup && (
        <div
          style={{
            backgroundColor: 'rgba(0,0,0,0.4)',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            padding: '15px',
            boxSizing: 'border-box',
          }}
        >
          <div
            ref={wrapperRef}
            style={{
              width: '100%',
              maxWidth: '650px',
              margin: '100px auto 0',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '24px 35px',
                backgroundColor: '#007AC3',
                borderRadius: '30px 30px 0px 0px',
              }}
            >
              <div
                style={{
                  maxWidth: '300px',
                  fontFamily: 'TTRounds',
                  fontStyle: 'normal',
                  fontWeight: 'bold',
                  fontSize: '26px',
                  lineHeight: '30px',
                  color: '#fff',
                }}
              >
                Your Customer Discount Code (CDP)
              </div>
              <div style={{ paddingLeft: 10 }}>
                <button
                  type="button"
                  style={{ border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}
                  onClick={() => setPopup.false()}
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.3525 1.38372C17.7667 0.797933 16.8169 0.797933 16.2311 1.38372L9.86719 7.74768L3.50323 1.38372C2.91744 0.797932 1.96769 0.797932 1.38191 1.38372C0.796119 1.96951 0.796119 2.91925 1.38191 3.50504L7.74587 9.869L1.3819 16.233C0.796119 16.8187 0.796118 17.7685 1.3819 18.3543C1.96769 18.9401 2.91744 18.9401 3.50323 18.3543L9.86719 11.9903L16.2311 18.3543C16.8169 18.9401 17.7667 18.9401 18.3525 18.3543C18.9383 17.7685 18.9383 16.8187 18.3525 16.233L11.9885 9.869L18.3525 3.50504C18.9383 2.91925 18.9383 1.96951 18.3525 1.38372Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div
              style={{
                padding: '24px 35px',
                backgroundColor: '#fff',
                borderRadius: ' 0px 0px 30px 30px',
              }}
            >
              <div
                style={{
                  fontFamily: 'TTRounds',
                  fontStyle: 'normal',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  lineHeight: '22px',
                  color: '#007AC3',
                  marginBottom: 10,
                }}
              >
                Unfortunately your customer discount code (CDP) is no longer valid
              </div>
              <div
                style={{
                  fontStyle: 'normal',
                  fontWeight: 300,
                  fontSize: '16px',
                  lineHeight: '30px',
                }}
              >
                <div style={{ marginBottom: 25 }}>
                  <div className={classes.popupItem}>
                    <div>
                      You will need to re-enrol again{' '}
                      <a style={{ color: '#007AC3' }} href="/blue-chip" target="_blank">
                        here
                      </a>{' '}
                      however please use this discount code <b>2226214</b> in the interim
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <p className="globalLocationsIntro">
        Book Thrifty in Australia, New Zealand, America, Canada and Europe
      </p>
      <div className="con">{children}</div>
      <div className="con2">
        {promoCampaign === '' &&
          getCookie('loggedIn') !== 'true' &&
          (getCookie('iataCode') === null || getCookie('iataCode') === '') && (
            <div
              style={{
                position: 'relative',
                width: '310px',
                display: 'inline-block',
                marginRight: 15,
                paddingTop: 15,
              }}
            >
              <a
                onClick={e => {
                  e.preventDefault()
                  if (blueChipMemberDropdown) setBlueChipMemberDropdown.false()
                  else setBlueChipMemberDropdown.true()
                }}
                href="#"
                style={{
                  backgroundColor: '#01588B',
                  borderRadius: 14,
                  color: '#fff',
                  textDecoration: 'none',
                  padding: '11px 20px',
                  fontFamily: 'TTRounds',
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  display: 'flex',
                  fontSize: '16px',
                  lineHeight: '20px',
                  justifyContent: 'space-between',
                }}
              >
                <span>I am a Blue Chip member</span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#007AC3" />
                  <path
                    d="M17 10L12 15L7 10"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
              {blueChipMemberDropdown && (
                <div
                  ref={bluechipWrapperRef}
                  style={{
                    position: 'absolute',
                    top: 15,
                    left: 0,
                    width: '100%',
                    background: '#fff',
                    zIndex: 1,
                    padding: '8px 8px 0 8px',
                    border: '1px solid #ccc',
                    borderTop: 0,
                    boxShadow: '2px 10px 30px rgba(0, 0, 0, 0.25)',
                    borderRadius: 14,
                    boxSizing: 'border-box',
                  }}
                >
                  <div
                    style={{
                      fontSize: '15px',
                      marginTop: '3px',
                      marginRight: '11px',
                      marginLeft: '11px',
                      marginBottom: '0px',
                      fontFamily: 'TTRounds',
                      fontWeight: '500',
                      textAlign: 'left',
                      color: '#01588B',
                      opacity: '1',
                      display: 'flex',
                      fontSize: '16px',
                      lineHeight: '20px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>I am a Blue Chip member</span>
                    <svg
                      style={{ transform: 'rotate(180deg)' }}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={e => {
                        e.preventDefault()
                        if (blueChipMemberDropdown) setBlueChipMemberDropdown.false()
                        else setBlueChipMemberDropdown.true()
                      }}
                    >
                      <circle cx="12" cy="12" r="12" fill="#007AC3" />
                      <path
                        d="M17 10L12 15L7 10"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div style={{ padding: '15px 8px 0 8px' }}>
                    <div style={{ marginBottom: 15 }}>
                      <FormInput
                        error={blueschipError ? [] : undefined}
                        noMarginBottom
                        lessPadding
                        greyBackground
                        labelText="Blue Chip Number*"
                        inputName="setbluechipnumber"
                        inputType="text"
                        defaultValue={bluechipnumber}
                        onChange={e => setbluechipnumber(e.target.value)}
                      />
                    </div>
                    <div style={{ marginBottom: 15 }}>
                      <FormInput
                        error={blueschipError}
                        noMarginBottom
                        lessPadding
                        greyBackground
                        labelText="Last name*"
                        inputName="bluechipname"
                        inputType="text"
                        defaultValue={bluechipname}
                        onChange={e => setbluechipname(e.target.value)}
                      />
                    </div>
                    {bluechiperror && (
                      <div
                        style={{
                          marginBottom: 15,
                          color: 'red',
                          fontSize: 12,
                          lineHeight: 1.75,
                          fontWeight: 300,
                        }}
                      >
                        You will need to re-enrol again{' '}
                        <a style={{ color: 'red' }} href="/blue-chip">
                          here
                        </a>
                      </div>
                    )}
                    {bluechipsuccess && (
                      <div
                        style={{
                          marginBottom: 15,
                          color: 'green',
                          fontSize: 12,
                          lineHeight: 1.75,
                          fontWeight: 300,
                        }}
                      >
                        Your Bluechip has been successfully added to this booking
                      </div>
                    )}
                    <div style={{ marginBottom: 15 }}>
                      <button
                        disabled={blueChipMembershipDisable}
                        type="button"
                        className="btnbs"
                        onClick={_checkBlueChip}
                      >
                        Validate
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

        {promoCampaign === 'velocity-promo' && window.location.hostname.includes('.au') && (
          <div
            style={{
              position: 'relative',
              width: '310px',
              display: 'inline-block',
              marginRight: 15,
              paddingTop: 15,
            }}
          >
            <a
              onClick={e => {
                e.preventDefault()
                setVelocityDropdown.true()
              }}
              href="#"
              style={{
                backgroundColor: '#01588B',
                borderRadius: 14,
                color: '#fff',
                textDecoration: 'none',
                padding: '11px 20px',
                fontFamily: 'TTRounds',
                fontStyle: 'normal',
                fontWeight: 'normal',
                display: 'flex',
                fontSize: '16px',
                lineHeight: '20px',
                justifyContent: 'space-between',
              }}
            >
              <span>Velocity number</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#007AC3" />
                <path
                  d="M17 10L12 15L7 10"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            {velocityDropdown && (
              <div
                ref={velocityWrapperRef}
                style={{
                  position: 'absolute',
                  top: 15,
                  left: 0,
                  width: '100%',
                  background: '#fff',
                  zIndex: 1,
                  padding: '8px 8px 0 8px',
                  border: '1px solid #ccc',
                  borderTop: 0,
                  boxShadow: '2px 10px 30px rgba(0, 0, 0, 0.25)',
                  borderRadius: 14,
                  boxSizing: 'border-box',
                }}
              >
                <div
                  style={{
                    fontSize: '15px',
                    marginTop: '3px',
                    marginRight: '11px',
                    marginLeft: '11px',
                    marginBottom: '0px',
                    fontFamily: 'TTRounds',
                    fontWeight: '500',
                    textAlign: 'left',
                    color: '#01588B',
                    opacity: '1',
                    display: 'flex',
                    fontSize: '16px',
                    lineHeight: '20px',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>Velocity number</span>
                  <svg
                    style={{ transform: 'rotate(180deg)' }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#007AC3" />
                    <path
                      d="M17 10L12 15L7 10"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div style={{ padding: '15px 8px 0 8px' }}>
                  <div style={{ marginBottom: 15 }}>
                    <FormInput
                      noMarginBottom
                      lessPadding
                      greyBackground
                      labelText="Velocity Number*"
                      inputName="setvelocitynumber"
                      inputType="text"
                      defaultValue={velocitynumber}
                      onChange={e => setvelocitynumber(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {window.location.pathname == '/' && (
        <div
          className="picstrip"
          style={{
            background:
              'linear-gradient(180deg, rgba(0,122,195,1) 0%, rgba(0,122,195,1) 50%, rgba(255,255,255,1) 51%, rgba(255,255,255,1) 100%',
            textAlign: 'center',
          }}
        >
          <img
            src="/themes/thrifty/assets/images/Thrifty_Elements-Stripes-Thin1.png"
            style={{ maxWidth: '100%' }}
          />
        </div>
      )}
      <div className="emptyspace" style={{ height: window.innerWidth < 1200 ? '30px' : '30px' }} />
    </div>
  )
}

export default BookingWidget
